<template>
  <v-layout row>
    <v-flex
      d-flex
      md12
    >
      <v-card>
        <v-form @submit.prevent>
          <v-container>
            <v-layout row>
              <v-flex md6>
                <v-text-field
                  v-model="cond.name"
                  label="名称"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  props: {
    cond: {
      type: Object,
      default: () => ({
        name: ''
      })
    }
  }
}
</script>
